export default __webpack_public_path__ + "static/Fellix-SemiBoldItalic-4840b16dafc8f1c1fe8a84712a5dac64.otf";